import React from "react";
import PropTypes from 'prop-types';
import styles from './apiList.less'

function ReqparamTable({ headerData = [] }) {
    return (
        <div id='reqparamtable' className={`${styles.reqparampanel} controledanchor`}>
            <h2>请求头参数</h2>
            {headerData.length ===0 
                ? <div className={styles.noData}>无</div>
                : <table>
                    <thead>
                        <tr>
                            <td>参数名称</td>
                            <td>参数值</td>
                            <td>说明</td>
                        </tr>
                    </thead>
                    <tbody>
                        {headerData.map((item, index) => {
                            return (
                                <tr key={index}>
                                    <td title={item.headername}>{item.headername}</td>
                                    <td title={item.headervalue}>{item.headervalue}</td>
                                    <td title={item.headerdes}>{item.headerdes}</td>
                                </tr>
                            )
                        })}
                    </tbody>
                </table>}
        </div>
    )
}
ReqparamTable.propTypes = {
    headerData: PropTypes.array
}
export default ReqparamTable;